import service from 'service';

export const getCategories = ({ queryKey: [, params] }) => {
  const url = '/cms/category';
  return service.get(url, { params });
};

export const createCategory = (payload) => {
  const url = '/cms/category';
  return service.post(url, payload);
};

export const showCategory = ({ queryKey: [, id] }) => {
  const url = `/cms/category/${id}`;
  return service.get(url);
};

export const getContents = ({ queryKey: [, id, params] }) => {
  const url = `/cms/category/${id}/content`;
  return service.get(url, { params });
};

export const createContent = ({ categoryId, ...payload }) => {
  const url = `/cms/category/${categoryId}/content`;
  return service.post(url, payload);
};

export const updateContent = ({ categoryId, contentId, ...payload }) => {
  const url = `/cms/category/${categoryId}/content/${contentId}`;
  return service.put(url, payload);
};
